import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Buy Energy Settings</h4>
    </div>
  );
};
